export default __webpack_public_path__ + "static/media/mail.f20ce59a.svg";